<template>
  <l-layout :layout="['xs12']">
    <v-form>
      <v-card class="pa-2">
        <v-layout column>
          <v-layout>
            <v-flex xs6>
              <v-text-field label="卡口名称" prepend-icon="$vuetify.icons.title" v-model="form.name" :disabled="disabledFlag" :rules="[$rules.requiredS()]"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-select :items="form.typeSelect" v-model="form.type" item-value="value" item-text="label" label="卡口类型" prepend-icon="$vuetify.icons.code"  :disabled="disabledFlag"
              :rules="[$rules.requiredS()]">
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-textarea label="卡口描述" prepend-icon="$vuetify.icons.comment" v-model="form.description" rows="1" auto-grow  :disabled="disabledFlag"></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout v-if="form.type==='unDir'">
            <v-flex xs12>
              <l-autocomplete
                :get-data="getParksByName"
                item-text="name"
                label="所属园区选择"
                prepend-icon="$vuetify.icons.parkingLot"
                v-model="form.park"
                :disabled="disabledFlag"
                multiple
                :rule="[$rules.requiredS()]"
              ></l-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout v-if="form.type==='dir'">
            <v-flex xs6>
              <l-autocomplete
                :get-data="getControllerByName"
                item-text="name"
                label="所属卡口选择"
                prepend-icon="$vuetify.icons.parkingLot"
                v-model="form.gate"
                :disabled="disabledFlag"
                :rule="[$rules.requiredS()]"
              ></l-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-select :items="form.gateTypeSelect" item-text="label" item-value="value" v-model="form.gateType" label="卡口类型"
                        prepend-icon="$vuetify.icons.code" clearable
                        :rule="[$rules.requiredS()]"
                        multiple :disabled="disabledFlag" chips></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <v-select :items="form.passTypeSelect" item-text="label" item-value="value" v-model="form.passType" label="通行类型"
                        prepend-icon="$vuetify.icons.location" clearable :rules="[$rules.requiredS()]"
                        :rule="[$rules.requiredS()]"
                         :disabled="disabledFlag" chips></v-select>
            </v-flex>
            <v-flex xs6 v-if="form.type==='dir'">
              <v-select :items="form.inOrOutSelect" item-text="label" item-value="value" v-model="form.inOrOut" label="出入类型选择"
                        prepend-icon="$vuetify.icons.location" clearable :rules="[$rules.requiredS()]"
                        :rule="[$rules.requiredS()]"
                        :disabled="disabledFlag" chips></v-select>
            </v-flex>
          </v-layout>
          <v-layout v-if="form.type==='dir'">
            <v-flex xs12>
              <l-autocomplete
                :get-data="getParksByName"
                item-text="name"
                label="驶入园区选择"
                prepend-icon="$vuetify.icons.parkingLot"
                v-model="form.entryParkId"
                :disabled="disabledFlag"
                multiple
              ></l-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout v-if="form.type==='dir'">
            <v-flex xs12>
              <l-autocomplete
                :get-data="getParksByName"
                item-text="name"
                label="驶出园区选择"
                prepend-icon="$vuetify.icons.parkingLot"
                v-model="form.departureParkId"
                :disabled="disabledFlag"
                multiple
              ></l-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout justify-center>
            <v-btn class="primary" @click="(form.type==='unDir')?addUnDirController():addDirController()"  :disabled="disabledFlag" :loading="loading">提交</v-btn>
          </v-layout>
        </v-layout>
      </v-card>
    </v-form>
  </l-layout>
</template>

<script>
export default {
  name: 'newController',
  data () {
    return {
      form: {
        typeSelect: [
          {value: 'dir', label: '有方向'},
          {value: 'unDir', label: '无方向'}
        ],
        gateType: [],
        gateTypeSelect: [
          {value: '0', label: '通行卡口'},
          {value: '1', label: '计费卡口'},
          {value: '2', label: '缴费卡口'},
          {value: '3', label: '边界卡口'},
        ],
        passType:"",
        passTypeSelect:[
          {value:'0',label:'人行卡口'},
          {value:'1',label:'车行卡口'}
        ],
        parkSelect: [],
        park: [],
        name: '',
        gate: '',
        description: '',
        latitude: '',
        longitude: '',
        entryParkId: [],
        departureParkId: [],
        inOrOut:"",
        inOrOutSelect:[
          {value:'0',label:'入口'},
          {value:'1',label:'出口'}
        ],
      },
      disabledFlag: false,
      loading: false
    }
  },
  methods: {
    getUserInfo () {
      return JSON.parse(sessionStorage.getItem('loginInfo'))
    },
    async getParksByName (val) {
      try {
        let {items} = await this.$store.dispatch('park/getParkList', {
          pagination: {page: 1, rowsPerPage: 100},
          search: {key: 'name', value: val},
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
        return []
      }
    },
    async getControllerByName (val) {
      try {
        let {items} = await this.$store.dispatch('park/getUnDirControllerList', {
          pagination: {page: 1, rowsPerPage: 100},
          search: {key: 'name', value: val},
        })
        return items
      }
      catch (e) {
        this.$L.alert('error', {message: e.message})
        return []
      }
    },
    checkForm () {
      return true
    },
    async addUnDirController () {
      if (this.checkForm()) {
        let parkId = []
        for(let i=0;i<this.form.park.length;i++){
          parkId.push(this.form.park[i].id)
        }
        let params = {
          'name': this.form.name,
          'description': this.form.description,
          'latitude': '',
          'longitude': '',
          'parkId': parkId,
          'passType': this.form.passType
        }
        this.loading = true
        let res = await this.$store.dispatch('park/addUnDirController', params)
        this.loading = false
        if (res.data.status + '' === '200') {
          this.disabledFlag = true
          this.$L.alert('success', {message: '添加成功'})
        }
        else {
          this.$L.alert('error', {message: '添加失败，原因:' + res.data.msg})
        }
      }
    },
    async addDirController () {
      if (this.checkForm()) {
        let entryParkId = []
        let departureParkId = []
        for (let i = 0; i < this.form.entryParkId.length; i++) {
          entryParkId.push(this.form.entryParkId[i].id)
        }
        for (let i = 0; i < this.form.departureParkId.length; i++) {
          departureParkId.push(this.form.departureParkId[i].id)
        }
        let params = {
          'name': this.form.name,
          'description': this.form.description,
          'latitude': '',
          'longitude': '',
          'gateId': this.form.gate.id,
          'gateType': JSON.stringify(this.form.gateType),
          'entryParkId': entryParkId,
          'departureParkId': departureParkId,
          'passType':this.form.passType,
          "inOrOut": this.form.inOrOut,
          "extend":null
        }
        this.loading = true
        let res = await this.$store.dispatch('park/addDirController', params)
        this.loading = false
        if (res.data.status + '' === '200') {
          this.disabledFlag = true
          this.$L.alert('success', {message: '添加成功'})
        }
        else {
          this.$L.alert('error', {message: '添加失败，原因:' + res.data.msg})
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
